import darkTheme from "./darkTheme.json";
import lightTheme from "./lightTheme.json";

export type Theme = typeof darkTheme;
export interface ThemeProp {
  theme: Theme;
}
export const themes = { dark: darkTheme, light: lightTheme };
